
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent {

  @Input() on: boolean;
  @Input() className: string;
  @Input() contentText: string;

  @Output()
  onChange = new EventEmitter<boolean>(true)

  onClick(){
    this.on = !this.on;
    this.onChange.emit(this.on);
  }
}
